/* eslint-disable no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export enum ToastVariant {
  success = 'success',
  error = 'error',
  warning = 'warning',
  neutral = 'neutral',
  toggle = 'toggle'
}

export enum ToastModel {
  Regular = 'Regular',
  Trends = 'Trends',
  NexaAI = 'NexaAI'
}

export interface ToastProps {
  text: string
  description: string
}

export interface ToastState {
  open: boolean
  variant: ToastVariant
  props: ToastProps | null
  toastModel: ToastModel
}

const initialState: ToastState = {
  open: false,
  variant: ToastVariant.success,
  props: null,
  toastModel: ToastModel.Regular
}

export const toastSlice = createSlice({
  name: 'Toasts',
  initialState,
  reducers: {
    openToast: (
      state: ToastState,
      action: PayloadAction<{
        variant?: ToastVariant
        props?: ToastProps
        toastModel?: ToastModel
      }>
    ) => {
      const { variant, props, toastModel } = action.payload

      state.props = props ?? null
      state.open = true
      state.variant = variant ?? ToastVariant.success
      state.toastModel = toastModel || ToastModel.Regular
    },
    closeToast: (state: ToastState) => {
      state.open = false
      state.props = null
      state.toastModel = ToastModel.Regular
    }
  }
})

export const toastPropsSelector = (state: RootState): ToastState => state.toasts

export const { openToast, closeToast } = toastSlice.actions

export default toastSlice.reducer
